import type {TMajorActionPlayAsCashData} from '@kapitalist/contract/types'
import {skins} from '~/game/skins'
import {cardFactory} from '~/models/game/factories'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMajorActionUserFacingDescriptionData} from '~/models/game/MajorAction'
import MajorAction from '~/models/game/MajorAction'
import type {AnyLiquidatableCard} from '~/models/game/types'
import {mutateIf} from '~/utils/etc'
import {inTense, sentenceCase} from '~/utils/language'

export default class MajorActionPlayAsCash extends MajorAction<TMajorActionPlayAsCashData> {
  card: AnyLiquidatableCard

  constructor(data: TMajorActionPlayAsCashData) {
    super(data)
    this.card = cardFactory(data.card)
  }

  public userFacingDescription({
    tense,
    skin,
    gamePosition,
  }: TMajorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined
    const majorActor = gamePosition.majorActorPlayer
    const dropFirstNoun = tense === 'imperativePrompt'

    return skins[skin].gameLogDescriptions.majorActions.playAsCash({
      tense,
      actor: dropFirstNoun
        ? undefined
        : currentPlayer?.id === majorActor.id
          ? 'You'
          : majorActor.username,
      playVerb: mutateIf(inTense(tense)('play'), dropFirstNoun, sentenceCase),
      cardName: this.card.displayName(skin),
    })
  }
}
